import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "panel"]

  connect() {
    // Store bound references to avoid memory leaks
    this._handleFrameLoad = (event) => this.handleFrameLoad(event)
    this._handleEscKey = (event) => this.handleEscKey(event)

    document.addEventListener('turbo:frame-load', this._handleFrameLoad)
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this._handleFrameLoad)
    document.removeEventListener('keydown', this._handleEscKey)
    // Clean up overflow-hidden in case user navigates away while modal is open
    document.body.classList.remove('overflow-hidden')
  }

  handleFrameLoad(event) {
    if (event.target.id === 'issue_detail' && event.target.innerHTML.trim() !== '') {
      this.open()
    }
  }

  open() {
    // Start in entering state (invisible)
    this.containerTarget.classList.add('modal-entering')
    this.containerTarget.classList.remove('hidden', 'modal-entered', 'modal-exiting')

    // Force reflow
    void this.containerTarget.offsetWidth

    // Transition to entered state
    this.containerTarget.classList.remove('modal-entering')
    this.containerTarget.classList.add('modal-entered')

    // Lock body scroll
    document.body.classList.add('overflow-hidden')

    // Listen for ESC
    document.addEventListener('keydown', this._handleEscKey)
  }

  close(event) {
    // Prevent link navigation when closing from within modal
    if (event && event.preventDefault) event.preventDefault()

    // Transition to exiting state
    this.containerTarget.classList.remove('modal-entered')
    this.containerTarget.classList.add('modal-exiting')

    // Wait for transition to finish, with fallback timeout
    const panel = this.panelTarget
    let cleaned = false

    const cleanup = () => {
      if (cleaned) return
      cleaned = true
      panel.removeEventListener('transitionend', onEnd)
      clearTimeout(fallback)

      this.containerTarget.classList.add('hidden')
      this.containerTarget.classList.remove('modal-exiting')

      // Clear turbo frame content
      const frame = document.getElementById('issue_detail')
      if (frame) frame.innerHTML = ''

      // Restore body scroll
      document.body.classList.remove('overflow-hidden')

      // Remove ESC listener
      document.removeEventListener('keydown', this._handleEscKey)
    }

    const onEnd = (e) => {
      if (e.target === panel) cleanup()
    }

    panel.addEventListener('transitionend', onEnd)
    const fallback = setTimeout(cleanup, 400)
  }

  closeModalAndScrollToCard(issueId) {
    this.close()

    setTimeout(() => {
      const cardElement = document.getElementById(`issue_card_${issueId}`)
      if (cardElement) {
        cardElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        })

        cardElement.style.transition = 'box-shadow 0.3s ease'
        cardElement.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.5)'

        setTimeout(() => {
          cardElement.style.boxShadow = ''
        }, 2000)
      }
    }, 400)
  }

  handleEscKey(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }
}

// Make the function globally accessible for Turbo Stream invoke
window.closeModalAndScrollToCard = (issueId) => {
  const modalController = document.querySelector('[data-controller="modal"]')
  if (modalController) {
    const stimulusApp = window.Stimulus || window.application
    if (stimulusApp) {
      const controller = stimulusApp.getControllerForElementAndIdentifier(modalController, 'modal')
      if (controller) {
        controller.closeModalAndScrollToCard(issueId)
      }
    }
  }
}
